import script from "./post-comment.vue?vue&type=script&setup=true&lang=js"
export * from "./post-comment.vue?vue&type=script&setup=true&lang=js"

import "./post-comment.vue?vue&type=style&index=0&id=2f4b0982&scoped=true&lang=css"

import exportComponent from "/Users/timtsang/VueProject/test-2-2/test-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f4b0982"]])

export default __exports__